export default "__VITE_ASSET__Dx1mfT5e__"